module.exports = __webpack_public_path__ + "static/media/A5.84f1c8a4.mp3";